function scrollToPoint(item = ".js-scroll-to") {
  $(item).on("click", function (event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    var dataTarget = $(this).data("href") ? $(this).data("href") : false; //JS SCROLL TO FIX WITH UTM
    var target = dataTarget ? $(dataTarget) : $(this.hash);
    target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
    if (target.length) {
      var stickyNavBlog = $(".sticky-nav-blog");
      var navHeight = $(".sticky-nav-with-banner").height() + 15;

      if (stickyNavBlog.length > 0) {
        navHeight = navHeight + stickyNavBlog.height() + 15;
      }

      $("html, body").animate(
        {
          scrollTop: target.offset().top - navHeight,
        },
        1000,
        function () {
          var $target = $(target);
          if ($target.is(":focus")) {
            return false;
          } else {
            $target.attr("tabindex", "-1");
          }
        }
      );
    }
  });
}

export default scrollToPoint;
